import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { ENDPOINT_DATA_COLLECTION, ENDPOINT_NEW_ANSWER } from '../../endpoints';
import { IEsOnehubVWConfig } from '../models/es-one-hub-config';

export const getDataCollection = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
): Promise<Response> => {
	const endpoint = ENDPOINT_DATA_COLLECTION;
	const response = await authServiceInstance.get(esOnehubVWConfig.resourceHostId, endpoint, {
		'Content-Type': 'application/json',
	});

	if (!response.ok) {
		throw new Error(`GET request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};

export const newAnswerDataCollection = async (
	authServiceInstance: IAuthServiceV2,
	esOnehubVWConfig: IEsOnehubVWConfig,
	questionAnswer: string[],
): Promise<Response> => {
	const endpoint = ENDPOINT_NEW_ANSWER;
	const response = await authServiceInstance.post(
		esOnehubVWConfig.resourceHostId,
		endpoint,
		JSON.stringify({ answers: questionAnswer }),
	);

	if (!response.ok) {
		throw new Error(`POST request failed with code ${response.status}`);
	}

	return response.json() as Promise<Response>;
};
